<script>
const storage = {
  data () {
    return {
      data: null
    }
  },
  methods: {
    getItem (key) {
      let item = localStorage.getItem(key)
      if (item) {
        try {
          return JSON.parse(item)
        } catch (e) {
          console.log(e)
        }
      }
      return item
    },
    setItem (key, data) {
      let parsed = JSON.stringify(data)
      localStorage.setItem(key, parsed)
    },
    removeItem (key, data) {
      localStorage.removeItem(key)
    },
    isLoggedIn () {
      return !!localStorage.getItem('access_token')
    },
    logout () {
      this.removeItem('user_id')
      this.removeItem('user_name')
      this.removeItem('user_avatar')
      this.removeItem('access_token')
      this.removeItem('fb_access_token')
    }
  }
}

export default storage
</script>



// WEBPACK FOOTER //
// src/utils/vue/LocalStorage.vue